var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"searchResultHeader mtp-1 mbm-1"},[_vm._v(" "+_vm._s(_vm.headerName)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }